<script setup lang="ts">
    import type { Nutzer } from '@/js/model'

    interface Props {
        id: string
        confirmationToken: string
    }

    const props = defineProps<Props>()
    const authStore = useAuthStore()
    const nutzer = ref<Nutzer | false>(false)

    const isLoading = computed(() => {
        return (
            authStore.isMethodLoading('isConfirmationTokenValid') ||
            authStore.isMethodLoading('bestaetigeNutzerEmail')
        )
    })

    onMounted(async () => {
        console.log(props)
        console.log(props.confirmationToken)
        try {
            await authStore.isConfirmationTokenValid({
                nutzer: `/api/nutzende/${props.id}`,
                confirmationToken: props.confirmationToken
            })

            nutzer.value = await authStore.bestaetigeNutzerEmail({
                nutzer: `/api/nutzende/${props.id}`,
                confirmationToken: props.confirmationToken
            })
            console.log('resulttttttttttt')
            console.log(nutzer.value)
        } catch (error) {
            nutzer.value = false
        }
    })
</script>

<template>
    <div class="d-flex align-items-center">
        <div v-if="isLoading" class="d-flex w-100 h-100 justify-center">
            <v-progress-circular indeterminate :size="128" :width="12" color="blue-lighten-3">
                <template v-slot:default>Prüfe Nutzer</template>
            </v-progress-circular>
        </div>
        <v-alert v-else-if="!nutzer" type="warning" prominent>
            Upps! Der von dir genutzte Link ist nicht länger gültig.
            <br />
            Bitte schaue nach, ob in deinem E-Mail-Postfach eine neuere E-Mail mit Link vorhanden
            ist oder melde dich beim Administrator.
        </v-alert>
        <v-alert
            v-else
            type="success"
            prominent
        >
            <p class="font-weight-bold">Herzlichen Glückwunsch {{ (nutzer as any).eMail?.value }}!</p>
            <ul class="text-left mt-3">
                <li>
                    Du hast deine E-Mail-Adresse <b>{{ (nutzer as any).eMail?.value }}</b> bestätigt und dein
                    Konto erfolgreich aktiviert.
                </li>
                <li>Du kannst dich jetzt mit deinen Zugangsdaten <v-btn :to="{name: 'login'}" variant="outlined" color="#00527e" density="compact" class="bg-white">einloggen</v-btn>.</li>
            </ul>
        </v-alert>
    </div>
</template>

<style scoped></style>
